import ConfigurarCuenta from "../components/configuracion/ConfigurarCuenta";

const Configuracion = () => {
	return <ConfigurarCuenta />;
};

export default Configuracion;
